import { PlusCircleIcon } from "@/components/icons/plus-circle-icon";
import { TextButton } from "@/components/ui/buttons";
import { cn } from "@/utils/cn";
import { textVariants } from "@/utils/text-variants";
import { memo } from "react";

interface MyPlanHeaderProps {
  onAddFoodClick: () => void;
}

export const MyPlanHeader = memo(function MyPlanHeader({ onAddFoodClick }: MyPlanHeaderProps) {
  return (
    <div className="flex w-full items-center justify-between px-4">
      {/* Spacer balances the add-food button so the title stays centered. */}
      <div className="h-11 w-11" aria-hidden />
      <h1 className={cn(textVariants.title3, "flex-1 text-center")}>Here's your plan today</h1>

      <TextButton className="flex h-11 w-11 items-center justify-center" onClick={onAddFoodClick}>
        <PlusCircleIcon className="h-6 w-6" />
      </TextButton>
    </div>
  );
});
